import type { FeedRefreshMinutes, FeedRunResult, FeedStatus } from '../api/types';

// Mirrors feedforge_ui/stores.py::_FEED_PATH_RE (spec §4).
const PATH_RE = /^(?!_tmp\/)[a-z0-9][a-z0-9_./-]{0,199}\.xml$/;
export function pathError(path: string): string | null {
  if (!PATH_RE.test(path) || path.includes('..') || path.includes('//')) {
    return 'Lowercase letters, digits, "/", "_", "-", "."; must end in .xml; no "..", no "//", not under _tmp/.';
  }
  return null;
}

export const REFRESH: { value: FeedRefreshMinutes; label: string }[] = [
  { value: 60, label: 'Every hour' }, { value: 240, label: 'Every 4 hours' },
  { value: 480, label: 'Every 8 hours' }, { value: 1440, label: 'Daily' },
];

export function describeResult(r: FeedRunResult): string {
  const s = r.stats ?? {};
  const counts = `${s.items_in ?? '?'} in → ${s.items_out ?? '?'} out · ${s.items_swapped ?? 0} branded · ${s.items_dropped ?? 0} left out`;
  switch (r.status) {
    case 'published': return `published · ${counts}`;
    case 'unchanged': return 'unchanged — source feed and renders are the same as the live feed';
    case 'refused':
      if (r.refusal === 'ratio') return `refused — only ${s.items_out} products would be published vs ${s.previous_items_out} last time (below 70%). Publish anyway if this is expected.`;
      if (r.refusal === 'zero_items') return `refused — 0 of ${s.items_in} products matched a render. Check that the feed's product ids are the ones we render, and that renders exist.`;
      return `refused — ${r.refusal}`;
    case 'error': return `error — ${r.error}`;
    default: return r.status;
  }
}

// Bucket base = the status's own public_url with its own path suffix stripped, so
// re-attaching a locally-edited draft path (not yet saved) still resolves to the
// right bucket.
export function feedUrlFor(status: FeedStatus | undefined, path: string): string | null {
  if (!status) return null;
  const bucketBase = status.public_url.slice(0, status.public_url.length - status.path.length);
  return `${bucketBase}${path}`;
}
